var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cn from 'classnames';
// @ts-ignore
import { getElementType } from 'semantic-ui-react/dist/commonjs/lib';
export const Text = (props) => {
    const { size, color, disabled, inverted, primary, secondary, positive, negative, textAlign, className, as } = props, rest = __rest(props, ["size", "color", "disabled", "inverted", "primary", "secondary", "positive", "negative", "textAlign", "className", "as"]);
    const classes = cn(className, 'ui', 'text', color, size, textAlign, {
        disabled,
        inverted,
        primary,
        positive,
        negative,
        secondary,
    });
    const ElementType = getElementType(Text, props);
    return React.createElement(ElementType, Object.assign({ className: classes }, rest));
};
Text.displayName = 'Text';
export default Text;
//# sourceMappingURL=Text.js.map